import React, { useState } from "react";
import {
  VideoCtaBase,
  VideoCtaContainer,
  Content,
  VideoEmbed,
  PrimaryCopy,
  CTAStyled,
  VideoIframe,
} from "./video-cta.styled";
import { VideoCtaSliceFragment } from "../../types/graphql";
import { PrismicRichText, SliceComponentProps } from "@prismicio/react";
import { htmlSerializer } from "../../utils/htmlSerializer";
import Youtube from "../youtube/youtube";
import { youtubeRegEx } from "../../utils/constants";
import { Slice } from "@prismicio/types";
import { IPageContext } from "../../types/types";
import { SharedSliceType } from "../shared-slice/shared-slice";
import VisibilitySensor from "react-visibility-sensor";

export type IVideoCtaProps = Slice<
  SharedSliceType,
  VideoCtaSliceFragment["primary"]
> & { type: SharedSliceType };

const VideoCta = ({
  slice,
  context,
}: SliceComponentProps<IVideoCtaProps, IPageContext>) => {
  const video = slice.primary?.video_url;
  const youtubeRegexMatch = video?.embed_url?.match(youtubeRegEx);
  const [hasViewed, setHasViewed] = useState(false);

  return (
    (slice && (
      <VideoCtaBase>
        <VisibilitySensor
          onChange={(isVisible: boolean) => isVisible && setHasViewed(true)}
          offset={{ bottom: -1200 }}
        >
          <VideoCtaContainer>
            <Content>
              <PrimaryCopy>
                {slice.primary?.primary_heading && (
                  <PrismicRichText
                    field={slice.primary?.primary_heading?.richText}
                    components={htmlSerializer}
                  />
                )}
                {slice.primary?.primary_description?.richText && (
                  <PrismicRichText
                    field={slice.primary?.primary_description.richText}
                    components={htmlSerializer}
                  />
                )}
                {slice.primary.cta_text && slice.primary.cta_link?.url && (
                  <CTAStyled
                    kind="primary"
                    pageSection="video-cta"
                    ctaText={slice.primary?.cta_text}
                    action={slice.primary?.cta_action}
                    linkURL={
                      slice.primary?.cta_link && slice.primary?.cta_link?.url
                    }
                    target={
                      slice.primary?.cta_link && slice.primary?.cta_link?.target
                    }
                  />
                )}
              </PrimaryCopy>
              {video && (
                <VideoEmbed>
                  {(youtubeRegexMatch &&
                    youtubeRegexMatch.length > 0 &&
                    hasViewed && (
                      <Youtube
                        embedURL={video.embed_url || ""}
                        thumbnailURL={video.thumbnail_url || ""}
                        title={video.title || ""}
                      />
                    )) ||
                    (video.embed_url && hasViewed && (
                      <VideoIframe
                        src={video.embed_url}
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      />
                    ))}
                </VideoEmbed>
              )}
            </Content>
          </VideoCtaContainer>
        </VisibilitySensor>
      </VideoCtaBase>
    )) || <></>
  );
};

export default VideoCta;
